import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {  Payment } from "../../Types/SiteMenuModel/Payment/Instalment";
import { getAllPaymentInstalment } from "../../Thunks/PaymentThunks";

interface PaymentSliceState {
    loader: boolean; // for refres pages and inital loadings
    payments: Payment|null;
    errorDisplay: string | null;
}

// set inital valus
const initialState : PaymentSliceState = {
    loader: false,
    payments: null,
    errorDisplay: '',

}

// set state valu for api response
const paymentSlice = createSlice ({
    name: 'paymentSlice',
    initialState,
    reducers : {
    },
    extraReducers(builder){
        builder.addCase(getAllPaymentInstalment.rejected, (state, action) => {
                    state.loader = false;
                    state.errorDisplay = action.error.message!;
                  })
                    .addCase(getAllPaymentInstalment.pending, state => {
                    state.loader = true;
                    state.errorDisplay = null;
                  })
                  .addCase(getAllPaymentInstalment.fulfilled, (state, action: PayloadAction<Payment>) => {
                    state.loader = false;
                    state.payments = action.payload;
                  })
    }
})

export const {} = paymentSlice.actions
export default paymentSlice.reducer